import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  ImageField,
  DisabledInput,
  TextInput,
  NumberInput,
  ImageInput,
  EditButton,
  DeleteButton,
  Create,
  Edit,
  SimpleForm,
} from 'admin-on-rest'
import { requireValidation, numberMinValidation, validateProductCreation } from './utils/validation'
import { ImageFieldOrNull, format, fixIfEmptyArray } from './common'

import ColorInput from 'aor-color-input';

export const ProductList = (props) => (
  <List {...props} sort={{ field: 'name', order: 'ASC' }} perPage={40}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="identifier" label="Name" />
      <ImageField source="icon" sortable={false} label="Product Icon" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
)

const ProductImage = ({ record }) => <img src={record.previewImage} alt="" />

const ProductTitle = ({ record }) => {
  return <span>Product {record ? `"${record.title}"` : ''}</span>
}

export const ProductEdit = (props) => (
  <Edit title={<ProductTitle />} {...props}>
    <SimpleForm validate={validateProductCreation}>
      <DisabledInput source="id" />
      <TextInput label="Title" source="title" />
      <TextInput label="Identifier" source="identifier" />
      <TextInput label="Description" source="description" />
      <ImageField source="icon" />
      <ImageInput source="icon" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
      <ProductImage />
      <ImageInput source="previewImage" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
      <ColorInput source="themeColor" picker="Sketch" validate={requireValidation}/>
    </SimpleForm>
  </Edit>
)

const imageInputRequired = [...requireValidation, fixIfEmptyArray]

export const ProductCreate = (props) => (
  <Create {...props}>
    <SimpleForm validate={validateProductCreation}>
      <ImageInput label="Icon" source="icon" accept="image/*" validate={imageInputRequired} format={format}>
        <ImageField source="src" />
      </ImageInput>
      <TextInput label="Ritual Identifier" source="identifier" validate={requireValidation} />
      <TextInput label="Ritual Name" source="title" validate={requireValidation} />
      <NumberInput label="Amount of Messages" source="questionsAmount" validate={numberMinValidation} />
      <ImageInput label="Cover Picture" source="previewImage" validate={imageInputRequired} accept="image/*" format={format}>
        <ImageField source="src" />
      </ImageInput>
      <TextInput label="Ritual Color" source="themeColor" validate={requireValidation} />
      <TextInput label="Description" source="description" />
      <ColorInput source="themeColor" picker="Sketch" validate={requireValidation}/>
    </SimpleForm>
  </Create>
)



// WEBPACK FOOTER //
// ./src/products.js